import React from 'react';
import { Card } from 'react-bootstrap';
import { MonthYearSelector } from './MonthYearSelector';
import { CalendarGrid } from './CalendarGrid';

export function Calendar({
    appointments,
    setAppointments,
    onDateSelect,
    selectedDate,
    currentDate,
    setSelectedButtonDate,
    onMonthChange
}) {
    return (
        <Card>
            <Card.Body>
                <MonthYearSelector
                    currentDate={currentDate}
                    onMonthChange={onMonthChange}
                />
                <CalendarGrid
                    currentDate={currentDate}
                    selectedDate={selectedDate}
                    setSelectedButtonDate={setSelectedButtonDate}
                    appointments={appointments}
                    setAppointments={setAppointments}
                    onDateSelect={onDateSelect}
                />
            </Card.Body>
        </Card>
    );
}